export class CustomDropdowns {
  initialize() {
    this.dropdowns = document.querySelectorAll(".custom-dropdown");
    this.dropdowns.forEach((dropdown) => new CustomDropdown(dropdown));
  }
}

export class CustomDropdown {
  constructor(dropdown) {
    this.dropdown = dropdown;
    this.selectElement = this.dropdown.querySelector("select");
    this.optionElements = this.selectElement.querySelectorAll("option");
    this.selectedOption = null;
    this.eventListeners = [];

    this.initialize();
  }

  initialize() {
    // Remove existing custom dropdown inner elements
    this.dropdown.querySelectorAll(".custom-dropdown__inner").forEach((inner) => {
        inner.remove();
    });

    // Create custom dropdown inner, hide the original select element, and render the custom dropdown
    this.customInner = document.createElement("div");
    this.customInner.classList.add("custom-dropdown__inner");
    this.dropdown.appendChild(this.customInner);

    // Hide original select
    this.selectElement.style.display = "none";

    this.options = Array.from(this.optionElements).map((option) => {
      return {
        value: option.value,
        text: option.text,
        image: option.dataset.image,
      };
    });

    this.render();
  }

  dropdownChange(e) {
    const value = e.target.dataset.value;
    this.selectElement.value = value;

    const changeEvent = new Event("change", { bubbles: true });
    this.selectElement.dispatchEvent(changeEvent);

    // Trigger the input event (to account for input-based form handlers)
    const inputEvent = new Event("input", { bubbles: true });
    this.selectElement.dispatchEvent(inputEvent);

    this.selectedOption = value;

    this.render();
  }

  toggleDropdown() {
    this.dropdown.classList.toggle("custom-dropdown--open");
  }

  closeDropdown() {
    this.dropdown.classList.remove("custom-dropdown--open");
  }

  addEventListeners() {
    console.log("add event listener");
    document.addEventListener("click", (e) => {
      if (!this.dropdown.contains(e.target)) {
        this.closeDropdown();
      }
    });

    this.dropdown
      .querySelector(".custom-dropdown__selected")
      .addEventListener("click", (e) => {
        e.stopPropagation();
        this.toggleDropdown();
      });

    this.dropdown
      .querySelectorAll(".custom-dropdown__option")
      .forEach((optionElement) => {
        optionElement.addEventListener("click", (e) => {
          this.dropdownChange(e);
          this.closeDropdown();
        });
      });

    this.dropdown
      .querySelector(".custom-dropdown__search input")
      .addEventListener("input", (e) => {
        const searchValue = e.target.value.toLowerCase();
        this.options.forEach((option) => {
          const optionElement = this.dropdown.querySelector(
            `.custom-dropdown__option[data-value="${option.value}"]`
          );

          if (option.text.toLowerCase().includes(searchValue)) {
            optionElement.style.display = "block";
          } else {
            optionElement.style.display = "none";
          }
        });
      });
  }

  render() {
    const selectedOption = this.options.find(
      (option) => option.value === this.selectElement.value
    );

    this.customInner.innerHTML = `
            <div class="custom-dropdown__selected">
                ${
                  selectedOption.image
                    ? `<img class="custom-dropdown__image" src="${selectedOption.image}" alt="${selectedOption.text}" />`
                    : ""
                }
                ${selectedOption.text}
            </div>
            <div class="custom-dropdown__options">
                <div class="custom-dropdown__search">
                    <input type="text" placeholder="Zoeken..." />
                </div>
                ${this.options
                  .map(
                    (option) => `
                    <div class="custom-dropdown__option" data-value="${
                      option.value
                    }">
                        ${
                          option.image
                            ? `<img class="custom-dropdown__image" src="${option.image}" alt="${option.text}" />`
                            : ""
                        }
                        ${option.text}
                    </div>
                `
                  )
                  .join("")}
            </div>
        `;

    this.addEventListeners();
  }
}
